import { useEffect, useState } from 'react'
import { getMe } from './api'

// undefined = loading, null = anonymous, object = signed in
export function useUser() {
  const [user, setUser] = useState(undefined)
  useEffect(() => {
    let cancelled = false
    getMe()
      .then((u) => {
        if (!cancelled) setUser(u)
      })
      .catch(() => {
        if (!cancelled) setUser(null)
      })
    return () => {
      cancelled = true
    }
  }, [])
  return user
}
